export const path = "/master-performance";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "MASTER CPL - CPA - CPI",
  section: "ALUNA",
  group: null,
  order: 1,
  roles: [
    "Authenticated",
    "aluna",
    "design",
    "aluna-management",
    "master-aluna-rrss",
    "aluna-afiliado",
  ],
};
